<template>
  <div class="row justify-content-center">
    <div class="col-lg-12">
      <b-alert
        class="col-11 col-sm-4 notification"
        :show="dismissCountDown"
        dismissible
        :variant="errorVariant"
        @dismissed="clearError()"
        @dismiss-count-down="countDownChanged"
      >
        <p>{{ errorMsg }}</p>
        <b-progress :variant="errorVariant" :max="dismissSecs" :value="dismissCountDown" height="4px" />
      </b-alert>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'NetworkError',
  computed: {
    networkError () {
      return this.$store.state.network.networkError
    },
    errorMsg () {
      if (this.networkError.type === 'Network') {
        return 'Error: ' + this.networkError.code + ' - ' + this.networkError.errorMessage
      } else if (this.networkError.type === 'Zero Results') {
        return this.$t('networkTransfers.networkErrors.networkError1')
      } else if (this.networkError.type === 'Results Limited') {
        return this.$t('networkTransfers.networkErrors.networkError2')
      } else return 'Error'
    },
    errorVariant () {
      if (this.networkError.type === 'Network') {
        return 'danger'
      } else if (this.networkError.type === 'Zero Results') {
        return 'warning'
      } else if (this.networkError.type === 'Results Limited') {
        return 'warning'
      } else return 'danger'
    },
    showError () {
      return this.networkError.error
    }
  },
  data () {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  methods: {
    ...mapMutations([
      'setNetworkError'
    ]),
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      if (!dismissCountDown) this.setNetworkError(false)
    },
    clearError () {
      this.dismissCountDown = 0
      this.setNetworkError(false)
    }
  },
  watch: {
    showError (val) {
      if (val) {
        this.dismissCountDown = this.dismissSecs
      }
    }
  }
}
</script>

<style scoped>
  .notification {
    display: inline-block;
    margin: 0px auto;
    position: fixed;
    z-index: 1033;
    top: 20px;
    right: 20px;
  }
</style>
